export class ExamStatisticRes {
  category: any = {
    Learning_Objective: {},
    Difficulty: {},
  };
  Chapter: any = {};
  Question_Types: any = {};
}
